/**
 * Mobile Quality landing. Quick-action tiles for on-site staff:
 * Cube Test, Raise NCR, Inspection Request, Raise Snag.
 *
 * Mobile_Safety_Quality_And_Nav_Cleanup (16-Sep-2026): split out of
 * MobileSafetyHome.jsx into its own destination + dedicated bottom-nav icon
 * so Quality is no longer hidden behind the "Safety" tab. Same
 * component/backend endpoints as before (/quality/ncrs etc.) — only the
 * mobile entry point changed.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { FlaskConical, FileWarning, ClipboardCheck, ClipboardList, BadgeCheck } from 'lucide-react';

const TILES = [
  { to: '/m/quality/cube-test', icon: FlaskConical, title: 'Cube Test', desc: 'Record a concrete pour' },
  { to: '/m/quality/ncr', icon: FileWarning, title: 'Raise NCR', desc: 'Log a non-conformance' },
  { to: '/m/quality/inspection', icon: ClipboardCheck, title: 'Inspection Request', desc: 'Request a stage inspection' },
  { to: '/m/quality/snag', icon: ClipboardList, title: 'Raise Snag', desc: 'Log a finishing defect' },
];

export default function MobileQualityHome() {
  return (
    <div className="px-5 pt-5 pb-6" data-testid="m-quality-home">
      <header className="mb-5 bg-gradient-to-br from-[#1d4ed8] to-[#1e3a8a] text-white rounded-2xl p-5 shadow-lg">
        <div className="text-[10px] uppercase tracking-[0.22em] text-white/70 font-display font-bold flex items-center gap-1.5">
          <BadgeCheck size={11} /> Quality
        </div>
        <h1 className="font-display font-bold text-2xl text-white mt-1 leading-tight">Log it now</h1>
        <p className="text-[11px] text-white/70 mt-1">Quality records are most accurate captured on-site.</p>
      </header>

      <div className="grid grid-cols-2 gap-3">
        {TILES.map((t) => (
          <Link
            key={t.to}
            to={t.to}
            data-testid={`m-quality-tile-${t.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
            className="group bg-white border border-slate-200 hover:border-[#1d4ed8]/50 rounded-2xl p-4 flex flex-col gap-3 active:scale-[0.97] transition-all shadow-sm hover:shadow-md min-h-[124px]"
          >
            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#1d4ed8] to-[#1e3a8a] text-white flex items-center justify-center shrink-0">
              <t.icon size={20} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-display font-bold text-[15px] text-slate-900 leading-tight">{t.title}</div>
              <div className="text-[11px] text-slate-500 mt-1 leading-snug">{t.desc}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
